<bon-topnav></bon-topnav>
<bon-sidebar></bon-sidebar>
<section [ngClass]="{'main-container-top-logo': false , 'main-container': true, sidebarPushRight: isActive }">
	<router-outlet></router-outlet>
</section>
